import React from 'react';

import style from './style.module.less';

import { FlexRow, FlexColumn, Gap } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

/**
 * @typedef {object} KeyMetricItem
 * @property {string|number} id - The unique id of the metric
 * @property {string} title - The title of the metric
 * @property {string|number} value - The value of the metric
 * @param {object} props
 * @param {KeyMetricItem[]} props.data
 * @returns {JSX.Element}
 */

export const KeyMetrics = ({ data }) => {
  return (
    <FlexRow className={style['key-metrics-wrapper']}>
      {data.map((item) => (
        <FlexColumn key={item.id} gap={Gap.Space2}>
          <Text className={style['key-metrics-title']} textType={TextType.Paragraph} value={item.title} />
          <Text className={style['key-metrics-value']} textType={TextType.H3} value={item.value} />
        </FlexColumn>
      ))}
    </FlexRow>
  );
};
